import { Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  /**
   * View container ref of the content from the sidenav. Dynamic components
   * should be injected in this view container ref.
   */
  public sidenavContent: ViewContainerRef;

  private readonly DEFAULT_SIDENAV_MAX_WIDTH = 40;
  readonly SIDENAV_MAX_WIDTH = 50;

  constructor() {}

  public opened$ = new BehaviorSubject<boolean>(false);
  public width$ = new BehaviorSubject<number>(this.DEFAULT_SIDENAV_MAX_WIDTH);

  setWidth(size) {
    this.width$.next(size);
  }

  open(componentFactory, width = this.DEFAULT_SIDENAV_MAX_WIDTH) {
    // this.sidenavContent.clear();
    this.sidenavContent.createComponent(componentFactory);
    this.opened$.next(true);
    this.width$.next(width);
  }

  close() {
    this.sidenavContent.clear();
    this.opened$.next(false);
    this.width$.next(this.DEFAULT_SIDENAV_MAX_WIDTH);
  }
}
